export default "https://cdn-static.gokick.com/assets/e21cd8011b9b3a74c4cd288f1b94a870d12ac47c/images/tangerine-flavor.1fe86552bc4a40407da21340599dcac8.png";